<template>
  <div class="catalogue">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem to="/host/index/home">首页</BreadcrumbItem>
          <BreadcrumbItem>供需审核</BreadcrumbItem>
          <BreadcrumbItem>采买供需</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">采买供需</div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="hostExcelExportBack">
          <i class="icon iconfont icon-downLoad2"></i>
          <span>导出</span>
        </div>
      </div>
      <!-- <div class="header-tool-box">
        <div class="htb-item" @click="addShow = true">
          <span class="htb-add">+</span>
          <span>添加车证</span>
        </div>
      </div> -->
    </div>
    <div class="header-tabs">
      <Tabs :animated="false" @on-click="switchBrand" v-model="showTabs">
        <TabPane label="已收回" name="0">
        </TabPane>
        <TabPane label="未接收/忽略" name="1">
        </TabPane>
        <TabPane label="已接收" name="2">
        </TabPane>
        <TabPane label="被拒绝" name="3">
        </TabPane>
      </Tabs>
    </div>

    <div class="layout-content" style="background: transparent;">
      <!-- <div v-if="list.length"> -->
      <div v-if="list.length">
        <Table :columns="showTabs=='2' ?columnsNoHandel:columns" :loading="loading" :data="list">
          <template slot-scope="{ row }" slot="companyName">{{row.cardInfoData.linkMan}}</template>
          <template slot-scope="{ row }" slot="mob">{{row.cardInfoData.mob}}</template>
          <template slot-scope="{ row }" slot="talkType">{{row.talkType}}</template>
          <template slot-scope="{ row }" slot="sourceName">{{row.sourceName}}</template>
          <template slot-scope="{ row }" slot="talkContent">{{row.talkContent}}</template>
          <template slot-scope="{ row }" slot="exOperator">{{row.exOperator}}</template>
          <template slot-scope="{ row }" slot="inTime">
            <span v-if="row.inTime">{{row.inTime | dateFormat}}</span>
          </template>

          <template slot-scope="{ row }" slot="isdeal">
            <!-- 0 -->
            <div v-if="showTabs=='0'">
              <span class="" v-if="row.isdeal==true">已处理</span>
              <Poptip confirm :title="PoptipTitle" @on-ok="setAudit(row)" placement="left">
                <span class="lookClass" v-if="row.isdeal==false" @click="handleP(row,'0')">未处理</span>
              </Poptip>

              <span class="spanClass" v-if="row.isdeal==false">|</span>
              <span class="deleteClass" style="cursor:pointer" v-if="row.isdeal==false" @click="rejectP(row,'0')">驳回</span>
            </div>

            <div v-if="showTabs=='1'">
              <Poptip confirm :title="PoptipTitle" @on-ok="setAudit(row)" placement="left">
                <span class="lookClass" @click="handleP(row,'1')">再次通知</span>
              </Poptip>
              <span class="spanClass">|</span>
              <span class="deleteClass" style="cursor:pointer" @click="rejectP(row,'1')">驳回</span>
            </div>
            <div v-if="showTabs=='3'">
              <Poptip confirm :title="PoptipTitle" @on-ok="setAudit(row)" placement="left">
                <span class="lookClass" @click="handleP(row,'3')">再激活</span>
              </Poptip>
              <!-- <span class="spanClass">|</span>
              <span class="deleteClass"
                    style="cursor:pointer"
                    @click="rejectP(row,'3')">驳回</span> -->
            </div>

            <!-- <span class="deleteClass"
                  @click="rejectP(row,'0')">驳回</span> -->
          </template>
        </Table>
        <div class="my-page" v-if="totalCount > pageSize" style="margin: 20px;text-align: center;">
          <Page show-total show-elevator :page-size="pageSize" :current="pageIndex" :total="totalCount" @on-change="changePage" @on-page-size-change="changePageSize" />
        </div>
      </div>
      <div class="u-empty" v-else>暂无数据</div>
    </div>

    <iModal :title="modelTitle" v-model="rejectModel" class-name="vertical-center-modal" width="600px" :mask-closable="false">

      <Input v-model="rejectValue" type="textarea" :rows="4" placeholder="请输入..."></Input>

      <div slot="footer">
        <Button type="primary" @click="handleSubmitReject()">确定</Button>
        <Button @click="rejectModel=false">取消</Button>
      </div>
    </iModal>
    <div class="catalogue-content"></div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
// import exhibitionCarYes from "./components/exhibition-car-yes";
// import exhibitionCarNo from "./components/exhibition-car-no";

export default {
  name: 'exhibition-info-carApply',
  data () {
    return {
      modalDetail: false,
      loading: false,

      editBrand: false,
      editBrandnfo: null,
      editTopic: false,
      editTopicnfo: null,
      search: '',
      editInfo: null,
      pageSize: 20,
      pageIndex: 1,
      totalCount: 0,
      columns: [
        // {
        //   type: 'selection',
        //   width: 60,
        //   align: 'center',
        // },
        {
          title: '发起人',
          slot: 'companyName',
          align: 'center',
        },
        {
          title: '手机',
          slot: 'mob',
          align: 'center',
          //   width: 200,
        },
        {
          title: '意向类型',
          slot: 'talkType',
          align: 'center',
        },
        {
          title: '接收方',
          slot: 'sourceName',
          align: 'center',
        },
        {
          title: '意向描述',
          slot: 'talkContent',
          align: 'center',
        },
        {
          title: '运营人员',
          slot: 'exOperator',
          align: 'center',
        },
        {
          title: '提交时间',
          slot: 'inTime',
          align: 'center',
        },
        {
          title: '操作',
          slot: 'isdeal',
          align: 'center',
        },
      ],
      columnsNoHandel: [
        // {
        //   type: 'selection',
        //   width: 60,
        //   align: 'center',
        // },
        {
          title: '发起人',
          slot: 'companyName',
          align: 'center',
        },
        {
          title: '手机',
          slot: 'mob',
          align: 'center',
          //   width: 200,
        },
        {
          title: '意向类型',
          slot: 'talkType',
          align: 'center',
        },
        {
          title: '接收方',
          slot: 'sourceName',
          align: 'center',
        },
        {
          title: '意向描述',
          slot: 'talkContent',
          align: 'center',
        },
        {
          title: '运营人员',
          slot: 'exOperator',
          align: 'center',
        },
        {
          title: '提交时间',
          slot: 'inTime',
          align: 'center',
        },
      ],
      list: [],
      selection: [], // 选中项目
      addShow: false,
      rejectModel: false,
      modelTitle: '',
      rowUser: {},
      showTabs: '0',
      PoptipTitle: '',
      option: {},
      stateInit: '',
      rejectValue: '',
    }
  },
  components: {
    // exhibitionCarYes,
    // exhibitionCarNo
  },
  computed: {
    ...mapGetters({
      exhibition: 'loginModule/getExhibition',
      exhibitionInfo: 'hostSetModule/getHostExhibition',
    }),
  },
  created () {
    document.title = '中国高等教育博览会 - 采买供需'
    this.init()
  },
  methods: {
    ...mapActions({
      getHostBuySupply: 'hostSetModule/getHostBuySupply',
      putHostUpdateState: 'hostSetModule/putHostUpdateState',
      getHostCallingAgain: 'hostSetModule/getHostCallingAgain',
      getBuyExport: 'hostSetModule/getBuyExport',
    }),
    switchBrand (name) {
      this.init()
    },

    async init () {
      if (this.showTabs == '0') {
        this.hour24 = false
        this.stateInit = '0,2'
      }
      if (this.showTabs == '1') {
        this.hour24 = true
        this.stateInit = '0,2'
      }
      if (this.showTabs == '2') {
        this.hour24 = false
        this.stateInit = '1'
      }
      if (this.showTabs == '3') {
        this.hour24 = false
        this.stateInit = '3'
      }
      this.option = {
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
        hour24: this.hour24,
        conditions: {
          state: this.stateInit,
        },
      }
      this.loading = true
      let proData = await this.getHostBuySupply(this.option)
      if (proData) {
        this.loading = false
        proData.items.map((c) => {
          if (c.categories) {
            c.categories = JSON.parse(c.categories)
          } else {
            c.categories = []
          }
          if (c.boothInfo) {
            c.boothInfo = JSON.parse(c.boothInfo)
          } else {
            c.boothInfo = []
          }
        })
        this.list = proData.items
        this.pageSize = proData.pageSize
        this.pageIndex = proData.pageIndex
        this.totalCount = proData.totalCount
      } else {
        this.loading = false
      }
    },

    async setAllAudit () {
      const reqList = []
      if (!this.selection.length) return
      this.selection.forEach((c) => {
        reqList.push(c.joinId)
      })
      const bool = await this.setOneStepAudit({
        joinIds: reqList,
      })
      if (bool && bool.successed) {
        this.$Message.success('操作成功')
        this.init()
      } else {
        this.$Message.error('操作失败，请重新尝试')
      }
    },
    changePage (e) {
      this.pageIndex = e
      this.init()
    },
    changePageSize (e) {
      this.pageSize = e
      this.init()
    },
    edit (item) {
      this.editInfo = item
    },
    searchPro () {
      this.pageIndex = 1
      this.init()
    },
    changeEvent (selection) {
      this.selection = selection
    },

    handleP (row, index) {
      if (this.showTabs == '0') {
        this.PoptipTitle = '是否已经处理完毕？'
      }
      if (this.showTabs == '1') {
        this.PoptipTitle = '确定要再次通知吗？'
      }
      if (this.showTabs == '3') {
        this.PoptipTitle = '确定要再次通知吗？'
      }
      if (this.showTabs == '4') {
        this.PoptipTitle = '您确定要激活吗？'
      }
    },
    async setAudit (row) {
      if (this.showTabs == '0') {
        console.log(row)
        const opt = {
          id: row.id,
          setValues: {
            Isdeal: true,
          },
        }
        const bool = await this.putHostUpdateState(opt)
        if (bool && bool.successed) {
          this.$Message.success('操作成功')
          this.init()
        } else {
          this.$Message.error('操作失败，请重新尝试')
        }
      }
      if (this.showTabs == '1') {
        console.log(row)
        const bool = await this.getHostCallingAgain(row.id)
        if (bool && bool.successed) {
          this.$Message.success('操作成功')
          this.init()
        } else {
          this.$Message.error('操作失败，请重新尝试')
        }
      }
      if (this.showTabs == '3') {
        let date = new Date(+new Date() + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, ' ')
          .replace(/\.[\d]{3}Z/, '')
        let endTime1 = new Date(`${date}`).toJSON() //2035-09-14T08:31:49.000Z
        console.log(row)
        const opt = {
          id: row.id,
          setValues: {
            Intime: endTime1,
            State: 0,
          },
        }
        console.log(opt)
        const bool = await this.putHostUpdateState(opt)
        if (bool && bool.successed) {
          this.$Message.success('操作成功')
          this.init()
        } else {
          this.$Message.error('操作失败，请重新尝试')
        }
      }
    },
    rejectP (row, index) {
      this.rejectValue = ''
      //   if (this.showTabs == '0') {
      this.rowUser = row
      this.modelTitle = '请填写驳回原因：'
      this.rejectModel = true
      //   }
    },
    async handleSubmitReject () {
      //   if (this.showTabs == '0') {
      if (!this.rejectValue) {
        this.$Message.warning('驳回理由不能为空！')
        return
      }
      const option = {
        id: this.rowUser.id,
        setValues: {
          RefuseReason: this.rejectValue,
          State: 3,
        },
      }
      let bool = await this.putHostUpdateState(option)
      if (bool && bool.successed) {
        this.rejectModel = false
        this.$Message.success('操作成功')
        this.init()
      } else {
        this.$Message.error('操作失败，请重新尝试')
      }
      //   }
    },
    // 主办导出
    async hostExcelExportBack () {
      if (this.showTabs == '0') {
        let opt = {
          pageSize: 500000,
          pageIndex: 1,
          hour24: false,
          conditions: {
            state: '0,2',
          },
        }
        let data = await this.getBuyExport(opt)
      }
      if (this.showTabs == '1') {
        let opt = {
          pageSize: 500000,
          pageIndex: 1,
          hour24: true,
          conditions: {
            state: '0,2',
          },
        }
        let data = await this.getBuyExport(opt)
      }
      if (this.showTabs == '2') {
        let opt = {
          pageSize: 500000,
          pageIndex: 1,
          hour24: true,
          conditions: {
            state: '1',
          },
        }
        let data = await this.getBuyExport(opt)
      }
      if (this.showTabs == '3') {
        let opt = {
          pageSize: 500000,
          pageIndex: 1,
          hour24: true,
          conditions: {
            state: '3',
          },
        }
        let data = await this.getBuyExport(opt)
      }
    },
  },
}
</script>

<style scoped lang="scss">
.catalogue {
  .header-tool {
    min-height: 90px;
  }
  &-content {
    min-width: 1000px;
    margin: 24px;
    padding: 40px;
    min-height: 500px;
    padding-bottom: 190px;
  }
}
.cib {
  min-width: 1000px;
  margin: 30px;
  padding: 40px;
  min-height: 500px;
  background: #fff;
  padding-bottom: 190px;
}
.spanClass {
  margin-left: 4px;
  margin-right: 4px;
}

.deleteClass {
  color: #f78989;
  // cursor:pointer;
}
.lookClass {
  color: #1890ff;
  cursor: pointer;
}
</style>
